/* (c) Dalineage, s.r.o. 2020-2025, all rights reserved */
package com.dalineage.client.objectbrowser

import scala.collection.immutable._

import com.dalineage.client
import client.adt.PropertyPanelADT

import com.dalineage.common
import common.adt.TreeNodeADT
import common.adt.ADT

import scala.util.chaining._

import upickle.default._

object ObjectBrowserContextMenu {
  import PropertyPanelADT.{Button, KeyValue, HelpText, Property}

  import common.adt.PropertyPanelADT.{PropertyName, ObjectType}

  import client.PropertyPanel.button

  implicit val positionRW: ReadWriter[ADT.Position] = macroRW
  implicit val rangeRW: ReadWriter[ADT.Range] = macroRW

  //tbd clean key parameter
  def menu( _key:String, node: TreeNodeADT.TreeNode ): List[PropertyPanelADT.Property] = {
    val key = node.key
    val positionStr = node.properties.get(PropertyName.CodePosition.id)
      .map(read[ADT.Range](_)).map(r => s"[$r]").getOrElse("N/A")
    HelpText("Object selected on <i>Object Browser</i>") ::
    KeyValue(PropertyName.ObjectType.toString, ObjectType(node.`type`).toString, None) ::
    KeyValue(PropertyName.ObjectKey.toString, key, None) ::
    KeyValue(PropertyName.ObjectName.toString, node.caption, None) ::
    KeyValue(PropertyName.CodePosition.toString, positionStr, None ) ::
    node.properties.toList
    .filter {
      case (k, v) => k != PropertyName.CodePosition.id
    }
    .map {
      case (k,v) => KeyValue(PropertyName(k).toString,v,None)
    } pipe {
      case list =>
        node.`type` match
          case objType if objType == ObjectType.Constant.id =>
            val b1 = Button("Select in code", 13, "objectBrowser")
            list ++ (HelpText(s"Press <b>ENTER</b> to ${button(b1)}")::Nil)
          case objType if objType == ObjectType.Source.id | objType == ObjectType.Query.id  =>
            val b1 = Button("See code", 13, "objectBrowser")
            node.properties.get(PropertyName.ParserError.id) match
              case None =>
                val b2 = Button("See detailed query lineage", 13, "objectBrowser", true)
                List(
                  s"Press <b>ENTER</b> to ${button(b1)}",
                  s"Press <b>Ctrl+ENTER</b> to ${button(b2)}"
                ) pipe { help => list ++ help.map(HelpText(_)) }
              case Some(err) =>
                List(
                  s"Press <b>ENTER</b> to ${button(b1)}"
                ) pipe { help => list ++ help.map(HelpText(_)) }
          case objType if objType == ObjectType.DBColumn.id =>
            //tbd
            list
          case _ => list
    } pipe { propList =>
      propList.map {
        case prop:KeyValue if prop.name == PropertyName.AnalyzerError.toString =>
          prop.copy(optClass = Some("aerr"))
        case prop:KeyValue if prop.name == PropertyName.ParserError.toString =>
          prop.copy(optClass = Some("perr"))
        case prop => prop
      }
    }
  }
}
